import produce from 'immer';

import {
  GET_CHALLENGE_REQUEST,
  GET_CHALLENGE_SUCCESS,
  GET_CHALLENGE_FAILURE,
  SET_CHALLENGE_RATING_REQUEST,
  SET_CHALLENGE_RATING_SUCCESS,
  SET_CHALLENGE_RATING_FAILURE,
  GET_TOURNAMENT_PLAYBACK_REQUEST,
  GET_TOURNAMENT_PLAYBACK_SUCCESS,
  GET_TOURNAMENT_PLAYBACK_FAILURE,
  RESET_STATE,
} from './constants';

const initialState = {
  loading: false,
  selectedChallenge: {},
  error: '',
};

export default (baseState = initialState, action) => {
  return produce(baseState, (state) => {
    switch (action.type) {
      case GET_CHALLENGE_REQUEST:
        state.loading = true;
        state.error = '';
        break;
      case GET_CHALLENGE_SUCCESS:
        state.loading = false;
        state.error = '';
        state.selectedChallenge = action.challenge;
        break;
      case GET_CHALLENGE_FAILURE:
        state.loading = false;
        state.error = action.error;
        break;
      case SET_CHALLENGE_RATING_REQUEST:
        state.loading = true;
        state.error = '';
        break;
      case SET_CHALLENGE_RATING_SUCCESS:
        state.loading = false;
        state.error = '';
        break;
      case SET_CHALLENGE_RATING_FAILURE:
        state.loading = false;
        state.error = action.error;
        break;
      case GET_TOURNAMENT_PLAYBACK_REQUEST:
        state.loading = true;
        state.error = '';
        break;
      case GET_TOURNAMENT_PLAYBACK_SUCCESS:
        state.loading = false;
        state.error = '';
        state.tournamentPlaybacks = action.tournamentPlaybacks;
        break;
      case GET_TOURNAMENT_PLAYBACK_FAILURE:
        state.loading = false;
        state.error = action.error;
        break;
      case RESET_STATE:
        state.selectedChallenge = {};
      default:
        break;
    }
  });
};
